import type { MenuModel } from '@launchmetrics/dmr-header-component/src/Model/header-models';

const isDlpLink = (link: string) => {
    if (!link) return false;
    const path = link.split(/[?#]/, 1)[0].toLowerCase();
    let end = path.length;
    while (end > 0 && path[end - 1] === '/') end--;
    return path.slice(0, end).endsWith('/dlpconfiguration');
};

// Filter stale menu responses immediately when changing to a disabled project.
// Menu DTO fields are lowercase (name/link/items), unlike the project DTO.
export function menuForDlpFeature(menu: MenuModel[], enabled: boolean): MenuModel[] {
    if (enabled) return menu;
    return menu.flatMap(item => {
        if (isDlpLink(item.link)) return [];
        if (!item.items) return [item];
        const items = item.items.filter(child => !isDlpLink(child.link));
        if (item.items.length > 0 && items.length === 0) return [];
        return [{ ...item, items }];
    });
}
